import styled from "styled-components";

export const Container = styled.div`
  --margin-spacing: clamp(36px, 50vw, 64px);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  & > aside {
    flex: 2;
    height: 100%;
    padding: 26px;
  }
  & > section {
    flex: 3;
  }
`;

export const SideView = styled.div`
  background-image: url(${(props) => props.bg});
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
  height: 100%;
  border-radius: 24px;
  position: relative;
  overflow: hidden;
  display: grid;
  place-items: center;
  z-index: 1;
  &:after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      360deg,
      rgba(68, 14, 105, 0.87) 13%,
      rgba(34, 27, 60, 0.87) 50.67%
    );
    z-index: 2;
  }
  & > * {
    position: relative;
    z-index: 3;
  }
`;

export const Logo = styled.img`
  position: absolute;
  /* inset: var(--margin-spacing) 0 0 var(--margin-spacing); */
  inset: 65px auto auto 65px;
`;

export const QuoteWrapper = styled.span`
  display: flex;
  flex-direction: column;
  width: calc(100% - 104px);
  gap: 12px;
`;

export const Dot = styled.img`
  position: absolute;
  right: clamp(120px, 20vw, 200px);
  top: clamp(140px, 12vw, 200px);
`;

export const FormView = styled.section`
  padding: 26px 110px 26px 26px;
`;
